<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div>
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item prop="schoolName">
                  <span slot="label" ><a-tooltip>{{$t('学校名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input disabled v-model="queryParam.schoolName" :maxLength="32" :placeholder="$t('请输入')+'学校名称'" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
      <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleExport" >
            <a-icon type="download" />{{$t('导出')}}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          v-table-sticky="{ fixedTop: 64 }"
          :scroll="{ x: 1200 }"
          class="sta-head-footer-table"
          :loading="loading"
          size="small"
          rowKey="goodsId"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <span slot="goodsType" slot-scope="text, record">
            <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType"/>
          </span>
          <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="handleSkuExport(record.goodsId)"  v-if="record.goodsId">
             <a-icon type="edit" />{{$t('导出发货明细表')}}
          </a>
          <a-divider type="vertical"/>
          <a @click="jumpSchoolGoodsStudent(record)"  v-if="record.goodsId">
             <a-icon type="edit" />{{$t('详情')}}
          </a>
        </span>
        </a-table>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {schoolGoodsSta} from '@/api/statistics/school'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import moment from 'moment';
import {areaListTree} from "@/api/logistics";
import {listSchoolLeader} from "@/api/school/schoolLeader";
import {downLoadExcel} from "@/utils/excelDownload";


export default {
  name: 'Goods',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      leaderList: [],
      areaList: [],
      cityList: [],
      schoolId: undefined,
      schoolName: undefined,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        schoolId: undefined,
        schoolName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          align: 'center'
        },
        {
          title: this.$t('商品图片'),
          dataIndex: 'picture',
          scopedSlots: { customRender: 'picture' },
          align: 'center'
        },
        {
          title: this.$t('学校名称'),
          dataIndex: 'schoolName',
          align: 'center'
        },
        {
          title: '商品销量',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'salesNum',
        },
        {
          title: '销售金额',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'payAmount',
        },
        {
          title: '运费',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'shippingPayAmount',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    };
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
    this.resetQuery();
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品列表 */
    getList () {
      let schoolId = this.$route.query.schoolId;
      if (schoolId) {
        this.schoolId = schoolId;
        this.schoolName = this.$route.query.schoolName;
      }
      this.loading = true
      this.queryParam.schoolId = this.schoolId;
      this.queryParam.schoolName = this.schoolName;
      schoolGoodsSta(this.queryParam).then(response => {
        this.list = response.data
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        schoolId: undefined,
        schoolName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.goodsId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    jumpSchoolGoodsStudent(record){
      //查看排行
      this.$router.push({
        path: '/statistics/school-goods-student-statistics',
        query: {schoolId: record.schoolId, goodsId: record.goodsId},
      })
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          downLoadExcel('biz/admin/statistics/school/goods/export' ,  that.queryParam)
        },
        onCancel () {}
      })
    },
    handleSkuExport (goodsId) {
      let queryParam = {
        "goodsId": goodsId,
        "schoolId": this.schoolId,
        "createBeginTime": this.queryParam.createBeginTime,
        "createEndTime": this.queryParam.createEndTime
      }
      this.$confirm({
        title: this.$t('是否确认导出'),
        onOk () {
          downLoadExcel('biz/admin/statistics/school/goods/sku/export' ,  queryParam)
        },
        onCancel () {}
      })
    },


  }
}
</script>
<style>
.sta-head-footer-table .ant-table-thead > tr > th {
  background-color: #bae7ff !important;
}
.sta-head-footer-table .ant-table-body tr:last-child td {
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 1;
  box-shadow: 5px 0 10px #e4e4e4;
}
</style>
